import { FunctionComponent, useCallback } from 'react';
import { Nav } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import { signOutUser } from '../../actions/user';

import { Link } from '../Link';
import { MigratePrivacy } from '../MigratePrivacy';

import classes from './sidebar.module.scss';

const routes = [
  { name: 'Profilo', route: '' },
  { name: 'I miei ordini', route: 'orders' },
  { name: 'I miei prodotti', route: 'warranty' },
  { name: 'Coupons', route: 'coupons' },
];

interface SideBarProps {
  contentClassName?: string;
  fluid?: boolean;
}

export const SideBar: FunctionComponent<SideBarProps> = ({
  children,
  contentClassName,
  fluid,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const signOut = useCallback(() => {
    dispatch(signOutUser());
    navigate('/');
  }, [dispatch, navigate]);

  return (
    <div className={classes.sideBar}>
      <div className={classes.navigationContainer}>
        <div className={classes.navigation}>
          <Nav className={'flex-column'} activeKey={location.pathname}>
            {routes.map(({ name, route }) => (
              <Nav.Link
                eventKey={`/${route}`}
                as={Link}
                to={`/${route}`}
                className={classes.navLink}
                key={route}
              >
                {name}
              </Nav.Link>
            ))}

            <Nav.Link
              role={'button'}
              onClick={signOut}
              className={classes.navLink}
            >
              Logout
            </Nav.Link>
          </Nav>
        </div>
      </div>

      <div>
        <div
          className={classNames(
            classes.content,
            fluid && classes.fluid,
            contentClassName
          )}
        >
          {children}
        </div>
      </div>

      <MigratePrivacy />
    </div>
  );
};
